import createReducer from 'utils/createReducer';

// Constants
export const formKeys = {
    CAPTCHA_TOKEN: 'CAPTCHA_TOKEN',
    NAME: 'NAME',
    EMAIL: 'EMAIL',
    COMPANY: 'COMPANY',
    NOTE: 'NOTE',
};

export const STATUS_IDLE = 'STATUS_IDLE';
export const STATUS_SUCCESS = 'STATUS_SUCCESS';
export const STATUS_LOADING = 'STATUS_LOADING';
export const STATUS_ERROR = 'STATUS_ERROR';

const SET_VALUE = 'SET_VALUE';
const SET_ERROR = 'SET_ERROR';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const SET_SUBMISSION_STATUS = 'SET_SUBMISSION_STATUS';
const SET_VALIDATING = 'SET_VALIDATING';

// Initial state
export const initState = {
    form: {
        [formKeys.CAPTCHA_TOKEN]: {
            value: null,
            error: null,
        },
        [formKeys.NAME]: {
            value: null,
            error: null,
        },
        [formKeys.EMAIL]: {
            value: null,
            error: null,
        },
        [formKeys.COMPANY]: {
            value: null,
            error: null,
        },
        [formKeys.NOTE]: {
            value: null,
            error: null,
        },
    },
    submissionStatus: STATUS_IDLE,
    isValidating: false,
};

// Reducer
export const reducer = createReducer(initState, {
    [SET_VALUE]: (state, { payload }) => ({
        ...state,
        form: {
            ...state.form,
            [payload.key]: {
                value: payload.value,
                error: null,
            },
        },
        isValidating: false, // Stop announcing when user starts typing
    }),
    [SET_ERROR]: (state, { payload }) => ({
        ...state,
        form: {
            ...state.form,
            [payload.key]: {
                ...state.form[payload.key],
                error: payload.error,
            },
        },
    }),
    [CLEAR_ERRORS]: (state) => ({
        ...state,
        form: Object.keys(state.form).reduce(
            (acc, key) => ({
                ...acc,
                [key]: {
                    ...state.form[key],
                    error: null,
                },
            }),
            {},
        ),
    }),
    [SET_SUBMISSION_STATUS]: (state, { payload }) => ({
        ...state,
        submissionStatus: payload,
    }),
    [SET_VALIDATING]: (state, { payload }) => ({
        ...state,
        isValidating: payload,
    }),
});

// Actions
export const setValue = (key, value) => ({
    type: SET_VALUE,
    payload: {
        key,
        value,
    },
});

export const setError = (key, error) => ({
    type: SET_ERROR,
    payload: {
        key,
        error,
    },
});

export const clearErrors = () => ({
    type: CLEAR_ERRORS,
});

export const setSubmissionStatus = (status) => ({
    type: SET_SUBMISSION_STATUS,
    payload: status,
});

export const setValidating = (isValidating) => ({
    type: SET_VALIDATING,
    payload: isValidating,
});

// Selectors
export const getFormValue = (state, key) => state.form[key].value;
export const getFormError = (state, key) => state.form[key].error;
export const getSubmissionStatus = (state) => state.submissionStatus;

// Announcement priority: Email → Note → reCAPTCHA (only during validation)
export const getAnnouncementError = (state) => {
    const emailError = getFormError(state, formKeys.EMAIL);
    const noteError = getFormError(state, formKeys.NOTE);
    const captchaError = getFormError(state, formKeys.CAPTCHA_TOKEN);
    const { isValidating } = state;

    if (emailError) return { key: formKeys.EMAIL, message: emailError };
    if (noteError) return { key: formKeys.NOTE, message: noteError };
    if (captchaError && isValidating) return { key: formKeys.CAPTCHA_TOKEN, message: captchaError };
    return null;
};
